import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { MAPBOX_API_KEY, MAPBOX_STYLE } from "../../utils/constants";
import "./styles.css";

export default function State({ geometry }) {
  const [map, setMap] = useState(null);
  const mapContainer = useRef(null);

  useEffect(() => {
    //Initializing Map
    mapboxgl.accessToken = MAPBOX_API_KEY;

    const initializeMap = ({ setMap, mapContainer }) => {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: MAPBOX_STYLE,
        center: [79.130933, 22.454834],
        zoom: 5.5,
        interactive: false
      });

      map.on("load", () => {
        setMap(map);
        map.resize();
        map.addSource("maine", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: geometry
          }
        });
        map.addLayer({
          id: "maine",
          type: "fill",
          source: "maine",
          layout: {},
          paint: {
            "fill-color": "#088",
            "fill-opacity": 0.8
          }
        });
      });

      map.flyTo({ center: geometry.coordinates[0][0][0] });

      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true
        })
      );

      //Navigation
      var nav = new mapboxgl.NavigationControl();

      map.addControl(nav, "top-left");
    };

    if (!map) initializeMap({ setMap, mapContainer });
  }, [geometry, map]);

  return (
    <div ref={el => (mapContainer.current = el)} className="container">
      <div id="map"></div>
    </div>
  );
}
